"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-ai-logo.tsx
var AiLogo = function AiLogo(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1.5H4C2.61929 1.5 1.5 2.61929 1.5 4V16C1.5 17.3807 2.61929 18.5 4 18.5H16C17.3807 18.5 18.5 17.3807 18.5 16V4C18.5 2.61929 17.3807 1.5 16 1.5ZM4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4Z",
    fill: "url(#paint0_linear_2952_1676)"
  }), (0, _preact.h)("path", {
    d: "M7.939 15C8.67929 15 9.30501 14.7334 9.81617 14.2002C9.86905 14.5087 9.93074 14.7312 10.0012 14.8678H11.6405V14.7554C11.4598 14.3721 11.3695 13.8587 11.3695 13.2154V9.9898C11.3562 9.22747 11.1007 8.6359 10.6027 8.21508C10.1048 7.79426 9.43721 7.58385 8.59997 7.58385C8.04916 7.58385 7.55012 7.68079 7.10286 7.87468C6.6556 8.06857 6.30198 8.33626 6.042 8.67777C5.78202 9.01927 5.65202 9.38611 5.65202 9.77828H7.25819C7.25819 9.49627 7.37497 9.26383 7.60851 9.08096C7.84205 8.89809 8.1417 8.80666 8.50744 8.80666C8.93046 8.80666 9.24552 8.91792 9.45263 9.14044C9.65974 9.36297 9.76329 9.65931 9.76329 10.0295V10.4987H8.77844C7.72528 10.4987 6.91559 10.7025 6.34935 11.1101C5.78312 11.5178 5.5 12.1027 5.5 12.865C5.5 13.4687 5.72693 13.9755 6.1808 14.3853C6.63467 14.7951 7.22074 15 7.939 15ZM8.23644 13.7111C7.89273 13.7111 7.61842 13.6197 7.41352 13.4368C7.20862 13.2539 7.10617 13.0082 7.10617 12.6998C7.10617 12.3208 7.25599 12.0278 7.55563 11.8207C7.85527 11.6136 8.30253 11.51 8.89741 11.51H9.76329V12.8584C9.62228 13.1184 9.41187 13.3255 9.13206 13.4798C8.85224 13.634 8.5537 13.7111 8.23644 13.7111ZM13.5883 6.70532C13.8792 6.70532 14.1039 6.6249 14.2625 6.46406C14.4212 6.30322 14.5005 6.10163 14.5005 5.85927C14.5005 5.6125 14.4212 5.4076 14.2625 5.24456C14.1039 5.08152 13.8792 5 13.5883 5C13.2975 5 13.0739 5.08152 12.9175 5.24456C12.761 5.4076 12.6828 5.6125 12.6828 5.85927C12.6828 6.10163 12.761 6.30322 12.9175 6.46406C13.0739 6.6249 13.2975 6.70532 13.5883 6.70532ZM14.3881 14.8684V7.71661H12.782V14.8684H14.3881Z",
    fill: "#181F26"
  }), (0, _preact.h)("defs", null, (0, _preact.h)("linearGradient", {
    id: "paint0_linear_2952_1676",
    x1: "20",
    y1: "0",
    x2: "0",
    y2: "20",
    gradientUnits: "userSpaceOnUse"
  }, (0, _preact.h)("stop", {
    stopColor: "#1CBFD6"
  }), (0, _preact.h)("stop", {
    offset: "0.315812",
    stopColor: "#798FFF"
  }), (0, _preact.h)("stop", {
    offset: "0.70686",
    stopColor: "#EC4BD2"
  }), (0, _preact.h)("stop", {
    offset: "1",
    stopColor: "#FFA34E"
  }))));
};

var _default = AiLogo;
exports.default = _default;